module.exports = __webpack_public_path__ + "static/media/rest.f6f55252.png";